import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styles from './styles.js'

const Divider = ({ color, type = 'normal', style = {} }) => (
  <div className={classnames('divider', type, color)} style={style}>
    <style jsx>{styles}</style>
  </div>
)

Divider.propTypes = {
  color: PropTypes.oneOf(['normal', 'gray']),
  type: PropTypes.oneOf(['normal', 'dashed']),
  style: PropTypes.object,
}

Divider.defaultProps = {
  color: 'normal',
}

export default Divider
